import type { UpdateSizingExperimentDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useQueryClient } from "@tanstack/react-query";

export default function useUpdateSizingExperiment(shopId: string) {
	const queryClient = useQueryClient();

	return useApiMutation(
		"patch",
		"/shops/{shopId}/sizing/experiments/{experimentId}",
		{
			invalidate: () => {
				queryClient.invalidateQueries({
					queryKey: ["get", "/shops/{shopId}/sizing/experiments"],
				});
			},
			mapVariables: (
				variables: UpdateSizingExperimentDto & { experimentId: string },
			) => ({
				params: {
					path: { shopId, experimentId: variables.experimentId },
				},
				body: {
					name: variables.name,
					splitPercent: variables.splitPercent,
				},
			}),
		},
	);
}
